<template>
  <div class="login">
    <el-row type="flex" justify="center" class="top-box">
      <el-col class="layout-container">
        <el-row class="login__banner">
          <el-col :span="16" class="hidden-xs-only login__banner__container">
            <el-carousel
              :height="carouselHeight"
              :interval="5000"
              arrow="always"
            >
              <el-carousel-item v-for="item in carousel" :key="item.id">
                <img
                  ref="img"
                  class="carousel__img"
                  :src="item.url"
                  @load="imgLoaded"
                  @click="handelTab('system')"
                />
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col
            :xs="24"
            :span="8"
            :style="{ height: carouselHeight }"
            class="login__form"
          >
            <el-row
              type="flex"
              justify="center"
              align="middle"
              style="height: 100%"
            >
              <el-col :span="14" class="login__form-inner">
                <!--
                <img
                  style="width: 80%;margin-bottom: 50px;margin-left: auto;margin-right: auto;display: block;"
                  src="../../static/img/login/login_logo_pampas_bg.png"
                />
                -->

                <div style="width: 100%; text-align: center; font-weight: bold">
                  智慧外贸服务平台-订单管理系统
                </div>
                <login-form
                  class="form"
                  @on-supply="handelTab('supply')"
                ></login-form>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!--<intro-content class="hidden-xs-only" ref="introContent"></intro-content>-->
    <!-- <login-footer class="hidden-xs-only"></login-footer> -->
  </div>
</template>

<script>
import { Message } from "element-ui";
import LoginForm from "./components/LoginForm";
import IntroContent from "./components/IntroContent";
import LoginFooter from "./components/LoginFooter";
import authApi from "@/api/auth";
import backgroundImg from "@/static/img/login/background.jpeg";
export default {
  components: {
    LoginForm,
    //,IntroContent
  },
  data() {
    return {
      carousel: [
        {
          id: 1,
          url: backgroundImg,
        },
      ],
      carouselHeight: "598px",
      checkLoaded: false,
    };
  },
  mounted() {
    const params = this.$route.params;
    if (params.activeName) {
      this.handelTab(params.activeName);
    }
    this.__resizeHandler = () => {
      if (document.body.clientWidth < 768) {
        this.carouselHeight = document.body.clientHeight + "px";
      } else {
        if (this.$refs.img[0].complete) {
          this.carouselHeight = `${this.$refs.img[0].height}px`;
        } else {
          this.$refs.img[0].onload = this.$refs.img[0].onresize = () => {
            this.carouselHeight = `${this.$refs.img[0].height}px`;
          };
        }
      }
    };
    window.addEventListener("resize", this.__resizeHandler);
    this.$store.dispatch("logOut");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.__resizeHandler);
  },
  methods: {
    handelTab(name) {
      this.$nextTick(() => {
        this.$refs.introContent.changeTab(name);
      });
    },
    imgLoaded() {
      if (!this.checkLoaded) {
        this.__resizeHandler();
      }
      this.checkLoaded = true;
    },
  },
};
</script>

<style lang="scss" scope>
@import "./Login.scss";
</style>
